const locale = "pl-PL";
const translations = {
	timeFormat: "HH:mm",
	dateFormat: "DD.MM.YYYY",
	dateTimeFormat: "DD.MM.YYYY HH:mm",
	"serviceReports.headline": "Raporty serwisu",
	"serviceReports.sublineMachine": "Tutaj można zobaczyć u pobrać raporty serwisu dotyczące Państwa maszyny.",
	"serviceReports.technicianName": "Nazwisko technika",
	"serviceReports.machineNameAndNumber": "Maszyna i nr maszyny",
	"serviceReports.startDate": "Od",
	"serviceReports.endDate": "Do",
	"serviceReports.creationDate": "Data utworzenia",
	"serviceReports.openReport": "Otwórz raport serwisu (PDF)",
	"serviceReports.filter": "Filtrowanie",
	"serviceReports.missionNumber": "Numer misji",
	"serviceReports.assignmentType": "Typ raportu serwisu",
	"serviceReports.reportTypes.IA": "Raport z demontażu/przestawienia",
	"serviceReports.reportTypes.AC": "Raport z doradztwa aplikacyjnego",
	"serviceReports.reportTypes.IV": "Raport z przygotowania instalacji",
	"serviceReports.reportTypes.BA": "Raport z inwentaryzacji",
	"serviceReports.reportTypes.UV": "Raport z kontroli bezpieczeństwa",
	"serviceReports.reportTypes.IG": "Raport z budowy maszyny używanej",
	"serviceReports.reportTypes.UB": "Raport z działań związanych z jakością",
	"serviceReports.reportTypes.PN": "Raport z nadzoru nad produkcją",
	"serviceReports.reportTypes.NR": "Raport z rozszerzenia funkcji",
	"serviceReports.reportTypes.IB": "Raport z instalacji/uruchomienia",
	"serviceReports.reportTypes.II": "Raport z integracji instalacji",
	"serviceReports.reportTypes.IC": "Raport z naprawy wewnętrznej",
	"serviceReports.reportTypes.MB": "Raport z obsługi targów",
	"serviceReports.reportTypes.HW": "Raport dotyczący zasobów",
	"serviceReports.reportTypes.TT": "Raport ze szkolenia techników",
	"serviceReports.reportTypes.SK": "Raport ze szkolenia klienta",
	"serviceReports.reportTypes.RP": "Raport z naprawy",
	"serviceReports.reportTypes.RW": "Raport z naprawy i konserwacji",
	"serviceReports.reportTypes.WA": "Raport z konserwacji",
	"serviceReports.reportTypesPlural.IA": "Raporty z demontażu/przestawienia",
	"serviceReports.reportTypesPlural.AC": "Raporty z doradztwa aplikacyjnego",
	"serviceReports.reportTypesPlural.IV": "Raporty z przygotowania instalacji",
	"serviceReports.reportTypesPlural.BA": "Raporty z inwentaryzacji",
	"serviceReports.reportTypesPlural.UV": "Raporty z kontroli bezpieczeństwa",
	"serviceReports.reportTypesPlural.IG": "Raporty z budowy maszyny używanej",
	"serviceReports.reportTypesPlural.UB": "Raporty z działań związanych z jakością",
	"serviceReports.reportTypesPlural.PN": "Raporty z nadzoru nad produkcją",
	"serviceReports.reportTypesPlural.NR": "Raporty z rozszerzenia funkcji",
	"serviceReports.reportTypesPlural.IB": "Raporty z instalacji/uruchomienia",
	"serviceReports.reportTypesPlural.II": "Raporty z integracji instalacji",
	"serviceReports.reportTypesPlural.IC": "Raporty z napraw wewnętrznych",
	"serviceReports.reportTypesPlural.MB": "Raporty z obsługi targów",
	"serviceReports.reportTypesPlural.HW": "Raporty dotyczące zasobów",
	"serviceReports.reportTypesPlural.TT": "Raporty ze szkolenia techników",
	"serviceReports.reportTypesPlural.SK": "Raporty ze szkolenia klienta",
	"serviceReports.reportTypesPlural.RP": "Raporty z napraw",
	"serviceReports.reportTypesPlural.RW": "Raporty z napraw i konserwacji",
	"serviceReports.reportTypesPlural.WA": "Raporty z konserwacji",
	"serviceReports.loadMore": "Wczytaj więcej",
	"serviceReports.loadError": "Błąd podczas pobierania danych",
	"serviceReports.noReportsFound": "Obecnie nie są dostępne żadne raporty serwisu.",
	"serviceReports.noReportsAvailable": "Obecnie nie są dostępne żadne raporty serwisu.",
	missingAuthorization: "Brakujące uprawnienie",
	"headline.createCase": "Tworzenie nowego przypadku serwisowego",
	"headline.caseDetails": "Szczegóły przypadku",
	"headline.contactData": "Dane kontaktowe",
	"field.reason.label": "Powód zgłoszenia",
	"field.machine.label": "Maszyna i nr maszyny",
	"field.softwareProblemClassification.label": "Klasyfikacja problemu",
	"field.softwareInstallationProblem.label": "Problem z instalacją",
	"field.softwareLicenseIssue.label": "Problem z licencją",
	"field.softwareType.label": "Typ oprogramowania",
	"field.softwareModule.label": "Moduł oprogramowania",
	"field.errorNumber.label": "Numery błędów",
	"field.errorNumber.explanation": "np. 0000FC00, 1.10.58102409 lub 6000",
	"field.errorNumber.addAnotherNumber": "więcej numerów błędu",
	"field.errorNumber.errorMessage": "Nieprawidłowy numer błędu",
	"field.message.label": "Wiadomość",
	"field.message.placeholder": "Proszę opisać (bez zwrotu powitalnego) swój przypadek/problem na tyle konkretnie, jak to tylko możliwe, i na tyle szczegółowo, jak to tylko konieczne. Dziękujemy.",
	"field.fileUpload.label": "Załączniki",
	"field.fileUpload.info": "Dozwolone formaty plików: IMG, JPG, PNG, PDF, HTML, pliki TruTops itp. (maks. 16 MB) oraz pliki wideo MP4 (maks. 50 MB)",
	"field.salutation.label": "Zwrot grzecznościowy",
	"field.salutation.male": "Pan",
	"field.salutation.female": "Pani",
	"field.firstName.label": "Imię",
	"field.lastName.label": "Nazwisko",
	"field.email.label": "E-mail",
	"field.phone.label": "Numer telefonu",
	"button.submit": "Wysyłanie",
	"button.cancel": "Anulowanie",
	"button.back": "wstecz",
	"button.next": "dalej",
	"button.close": "Zamknij",
	"button.ok": "Ok",
	"auth.error": "Wystąpił nieoczekiwany błąd.",
	"select.placeholder": "Wybierz…",
	"validation.requiredField": "To jest pole obowiązkowe",
	"validation.invalidEmail": "Proszę podać aktualny adres e-mail",
	"validation.maxAllowedCharacters": "Maksymalna liczba dozwolonych znaków: {{number}}",
	"validation.requiredFieldsExplanation": "Obowiązkowe pola oznaczono gwiazdką *.",
	"validation.invalidPhoneNumber": "Podaj prawidłowy numer telefonu.",
	"softwareProblemClassification.standstill": "Przestój",
	"softwareProblemClassification.fault": "Usterka",
	"softwareProblemClassification.slightImpairment": "Lekkie zakłócenia",
	"softwareProblemClassification.generalInquiry": "Ogólne zapytanie",
	"serviceCase.proactiveCaseClosure.title": "Informacja zwrotna i wniosek o zamknięcie przypadku",
	"serviceCase.proactiveCaseClosure.instructions": "Aby złożyć wniosek o zamknięcie przypadku i pomóc nam ulepszyć naszą usługę predykcyjną, uprzejmie prosimy o informację zwrotną.",
	"serviceCase.proactiveCaseClosure.question.submit": "Wysyłanie",
	"serviceCase.proactiveCaseClosure.dialogTitle": "Złożono wniosek o zamknięcie przypadku. Dziękujemy za informację zwrotną.",
	"serviceCase.proactiveCaseClosure.dialog.buttonOk": "Ok",
	"serviceCase.proactiveCaseClosure.question.anomaly": "Czy zgłoszona anomalia występowała w Państwa maszynie?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideLinked": "Czy udostępniono Technical Guide?",
	"serviceCase.proactiveCaseClosure.question.technicalGuideHelpful": "Czy udało się Państwu samodzielnie rozwiązać problem przy pomocy Technical Guides?",
	"serviceCase.proactiveCaseClosure.question.pauseRequest": "Czy chcą Państwo przerwać powiadomienia dla tego typu anomalii?",
	"serviceCase.proactiveCaseClosure.question.pauseRequestDuration": "Na jak długo chcą Państwo przerwać powiadomienia dla tego typu anomalii?",
	"serviceCase.proactiveCaseClosure.question.comment": "Prosimy wyjaśnić, dlaczego chcą Państwo przerwać powiadomienia dla tego typu anomalii:",
	"serviceCase.proactiveCaseClosure.question.commentPlaceholder": "Komentarz jest obowiązkowy, aby złożyć wniosek o zamknięcie przypadku i wysłać informację zwrotną",
	"serviceCase.proactiveCaseClosure.answers.yes": "Tak",
	"serviceCase.proactiveCaseClosure.answers.no": "Nie",
	"serviceCase.proactiveCaseClosure.answers.sevenDays": "7 dni",
	"serviceCase.proactiveCaseClosure.answers.fourteenDays": "14 dni",
	"serviceCase.proactiveCaseClosure.answers.thirtyDays": "30 dni",
	"serviceCase.proactiveCaseClosure.answers.ninetyDays": "90 dni",
	"sisConnector.success.headline": "Przypadek serwisowy został pomyślnie utworzony.",
	"sisConnector.success.orderNumberRequired.title": "Wskazówka:",
	"sisConnector.success.orderNumberRequired.text": "Należy dodać na stronie szczegółów sprawy numer katalogowy do rozliczenia sprawy i dodatkowe usługi.",
	"sisConnector.success.technicalGuide.title": "Dla tego numeru lub numerów błędu dostępny jest przewodnik techniczny.",
	"sisConnector.success.technicalGuide.text": "Na podstawie wprowadzonego numeru lub numerów błędu można było określić jeden lub więcej poradników technicznych. W ok. 50% przypadków wystarczy to do samodzielnego rozwiązania problemu. Ta funkcja jest dostępna tylko z odpowiednią umową serwisową.",
	"sisConnector.success.outsideOfServiceHours": "Należy pamiętać, że przypadki utworzone poza godzinami pracy serwisu nie są przetwarzane.",
	"sisConnector.success.serviceTimes.MonFri": "Nasz serwis jest otwarty od poniedziałku do piątku",
	"sisConnector.success.serviceTimes.Sat": "oraz w soboty",
	"sisConnector.success.withTechnicalServiceHotline": "Jeśli potrzeba natychmiastowej pomocy, proszę zadzwonić do serwisu technicznego TRUMPF ({{hotline}}), aby uzyskać wsparcie.",
	"sisConnector.success.withoutTechnicalServiceHotline": "Jeśli potrzeba natychmiastowej pomocy, proszę zadzwonić do serwisu technicznego TRUMPF, aby uzyskać wsparcie.",
	"sisConnector.success.caseId": "Numer zgłoszenia",
	"sisConnector.failed.headline": "Przypadek serwisowy nie mógł zostać utworzony.",
	"sisConnector.failed.unknownError": "Proszę spróbować ponownie lub skontaktować się z Państwa działem wsparcia."
};
var plPL = {
	locale: locale,
	translations: translations
};

export { plPL as default, locale, translations };
//# sourceMappingURL=pl-PL-BpoLqsKj.js.map

//# sourceMappingURL=pl-PL-BpoLqsKj.js.map